<template>
	<div class="card shadow mb-4">
        <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">
                Postulaciones 
                <span  
                v-if="usuario.cliente.id!=null && usuario.cliente.id!='null'">
                    por vacante
                </span>
                <span 
                v-else>
                    por empresa
                </span>
            </h6>
        </div>
        <div class="card-body">
            <div v-for="(vacante,index) in vacantes">
                <h4 class="small font-weight-bold">
                    {{vacante.nombre}}
                    <span class="float-right">
                        {{vacante.postulaciones}}
                    </span>
                </h4>
                <div class="progress mb-4">
                    <div 
                    :class="colors[index]"
                    class="progress-bar" 
                    role="progressbar" 
                    :style="{width: vacante.porcentaje+'%'}"
                    :aria-valuenow="vacante.porcentaje" 
                    aria-valuemin="0" 
                    aria-valuemax="100"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {firestore} from '@/firebase.js';
import {mapState} from 'vuex';
export default {
    data(){
        return {
            loading:true,
            vacantes:[],
            colors:[
                'bg-success',
                'bg-primary',
                'bg-danger',
                'bg-warning',
            ]
        }
    },
    methods:{
        ConsultarMisPostulaciones(){
            this.vacantes=[];
            this.loading=true;
            firestore.collection('clientes').doc(this.usuario.cliente.id)
            .collection('vacantes')
            .where('estatus','==',1)
            .orderBy('postulaciones','desc')
            .limit(5)
            .get().then(querySnapshot=>{
                let mayor=0;
                querySnapshot.forEach(doc=>{
                    this.vacantes.push({
                        nombre:doc.data().nombre,
                        postulaciones:doc.data().postulaciones
                    });
                });
                if (this.vacantes.length>0) {
                    mayor=this.vacantes[0].postulaciones;
                    for (var i = 0; i < this.vacantes.length; i++) {
                        this.vacantes[i].porcentaje=(this.vacantes[i].postulaciones*100)/mayor;
                    }
                }
            }).catch(error=>{
                console.log(error);
            }).finally(response=>{
                this.loading=false;
            });
        },
        ConsultarPostulacionesTotales(){
            this.vacantes=[];
            this.loading=true;
            firestore.collection('clientes')
            .where('estatus','==',1)
            .orderBy('postulaciones','desc')
            .limit(5)
            .get().then(querySnapshot=>{
                let mayor=0;
                querySnapshot.forEach(doc=>{
                    this.vacantes.push({
                        nombre:doc.data().nombre,
                        postulaciones:doc.data().postulaciones,
                        porcentaje:0
                    });
                });

                if (this.vacantes.length>0) {
                    mayor=this.vacantes[0].postulaciones;
                    for (var i = 0; i < this.vacantes.length; i++) {
                        this.vacantes[i].porcentaje=(this.vacantes[i].postulaciones*100)/mayor;
                    }
                }

            }).catch(error=>{
                console.log(error);
            }).finally(response=>{
                this.loading=false;
            });
        },
    },
    computed:{
        ...mapState(['usuario'])
    },
    created(){
        if (this.usuario.cliente.id!=null && this.usuario.cliente.id!='null') {
            this.ConsultarMisPostulaciones();
        }else{
            this.ConsultarPostulacionesTotales();
        }
        
    }
}    
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/postulaciones_grafica.vue